import React from 'react'
import { BrowserRouter, Routes, Route  } from 'react-router-dom'
import Adminpaysform from './Adminpaysform'

export default function Toptitre() {
  return (
    <div className='border-bottom white'>
        <center><h5>Plateforme de Co-production de l'information Climatique SHMN/Radios Communautaires </h5></center>
       
    </div>
  )
}
